import { h } from "@stencil/core"

export const srcScreenError = (screenName: string, errorMessage: string[]) => (
  <div>
    SRC {screenName} error: {errorMessage.join(", ")}
  </div>
)
